import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/upload-bank-report")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_authenticated/upload-bank-report"!</div>;
}
